import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import Typography from "ds/components/Typography";
import DrawerFooter from "ds/components/Drawer/Footer";
import DocumentationButton from "components/DocumentationButton";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getDocsUrl } from "utils/getDocsUrl";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";

import styles from "./styles.module.css";

const UsersInfoDrawerContent = () => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Users" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <Typography tag="h3" variant="p-t6">
          User access
        </Typography>
        <Typography tag="p" variant="p-body2" className={styles.description}>
          All users that have access to your account are listed here.
          <br />
          <br />
          You can manage access rules for anyone who logs into your account by selecting the 'manage
          roles' option after clicking the three dots to the right of the user entry.
          <br />
          <br />
          You can assign multiple roles to a single user within a given space. To create custom
          roles, go to the 'Roles' section in the left-hand menu.
          <br />
          <br />
          To invite new users to your account, click on the 'Invite user' button located in the top
          right corner. When you are inviting a user, you can set their access level, and in the end
          they will receive the invitation by email.
        </Typography>
        <DrawerFooter>
          <DocumentationButton
            label="Documentation"
            to={getDocsUrl("/concepts/identity-access-management/admin#users")}
            analyticsPage={AnalyticsPageOrganization.OrganizationUsers}
          />
        </DrawerFooter>
      </DrawerBody>
    </>
  );
};

export default UsersInfoDrawerContent;
